// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/stakeholders/firstparty/v1/update_stakeholder.proto

/* eslint-disable */
import { ApiStakeholderInput } from "./create_stakeholder";
import { ApiStakeholder } from "./stakeholder";

/** Request message for updating a stakeholder */
export interface ApiUpdateStakeholderRequest {
  /** The ID of the stakeholder to update */
  readonly id: string;
  /** The stakeholder data to update */
  readonly stakeholder: ApiStakeholderInput | null;
}

/** Response message for updating a stakeholder */
export interface ApiUpdateStakeholderResponse {
  /** The updated stakeholder */
  readonly stakeholder: ApiStakeholder | null;
}

/** Error codes for UpdateStakeholder operation */
export interface ApiUpdateStakeholderErrors {
}

/** Not found error codes */
export const ApiUpdateStakeholderErrorsNotFoundError = {
  /** NOT_FOUND_ERROR_UNSPECIFIED - Unspecified not found error */
  NOT_FOUND_ERROR_UNSPECIFIED: "NOT_FOUND_ERROR_UNSPECIFIED",
  /** NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED - Stakeholder not found or unauthorized */
  NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED: "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED",
} as const;

export type ApiUpdateStakeholderErrorsNotFoundError =
  typeof ApiUpdateStakeholderErrorsNotFoundError[keyof typeof ApiUpdateStakeholderErrorsNotFoundError];

export namespace ApiUpdateStakeholderErrorsNotFoundError {
  export type NOT_FOUND_ERROR_UNSPECIFIED = typeof ApiUpdateStakeholderErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  export type NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED =
    typeof ApiUpdateStakeholderErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED;
}

export function apiUpdateStakeholderErrorsNotFoundErrorFromJSON(object: any): ApiUpdateStakeholderErrorsNotFoundError {
  switch (object) {
    case 0:
    case "NOT_FOUND_ERROR_UNSPECIFIED":
      return ApiUpdateStakeholderErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
    case 1:
    case "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED":
      return ApiUpdateStakeholderErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED;
    default:
      return ApiUpdateStakeholderErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  }
}

export function apiUpdateStakeholderErrorsNotFoundErrorToJSON(object: ApiUpdateStakeholderErrorsNotFoundError): string {
  switch (object) {
    case ApiUpdateStakeholderErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
    case ApiUpdateStakeholderErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED:
      return "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED";
    default:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
  }
}

/** Bad request error codes */
export const ApiUpdateStakeholderErrorsBadRequestError = {
  /** BAD_REQUEST_ERROR_UNSPECIFIED - Unspecified bad request error */
  BAD_REQUEST_ERROR_UNSPECIFIED: "BAD_REQUEST_ERROR_UNSPECIFIED",
  /** BAD_REQUEST_ERROR_VALIDATION_FAILED - Validation failed */
  BAD_REQUEST_ERROR_VALIDATION_FAILED: "BAD_REQUEST_ERROR_VALIDATION_FAILED",
} as const;

export type ApiUpdateStakeholderErrorsBadRequestError =
  typeof ApiUpdateStakeholderErrorsBadRequestError[keyof typeof ApiUpdateStakeholderErrorsBadRequestError];

export namespace ApiUpdateStakeholderErrorsBadRequestError {
  export type BAD_REQUEST_ERROR_UNSPECIFIED =
    typeof ApiUpdateStakeholderErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED;
  export type BAD_REQUEST_ERROR_VALIDATION_FAILED =
    typeof ApiUpdateStakeholderErrorsBadRequestError.BAD_REQUEST_ERROR_VALIDATION_FAILED;
}

export function apiUpdateStakeholderErrorsBadRequestErrorFromJSON(
  object: any,
): ApiUpdateStakeholderErrorsBadRequestError {
  switch (object) {
    case 0:
    case "BAD_REQUEST_ERROR_UNSPECIFIED":
      return ApiUpdateStakeholderErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED;
    case 1:
    case "BAD_REQUEST_ERROR_VALIDATION_FAILED":
      return ApiUpdateStakeholderErrorsBadRequestError.BAD_REQUEST_ERROR_VALIDATION_FAILED;
    default:
      return ApiUpdateStakeholderErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED;
  }
}

export function apiUpdateStakeholderErrorsBadRequestErrorToJSON(
  object: ApiUpdateStakeholderErrorsBadRequestError,
): string {
  switch (object) {
    case ApiUpdateStakeholderErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED:
      return "BAD_REQUEST_ERROR_UNSPECIFIED";
    case ApiUpdateStakeholderErrorsBadRequestError.BAD_REQUEST_ERROR_VALIDATION_FAILED:
      return "BAD_REQUEST_ERROR_VALIDATION_FAILED";
    default:
      return "BAD_REQUEST_ERROR_UNSPECIFIED";
  }
}

export const ApiUpdateStakeholderRequest: MessageFns<ApiUpdateStakeholderRequest> = {
  fromJSON(object: any): ApiUpdateStakeholderRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      stakeholder: isSet(object.stakeholder) ? ApiStakeholderInput.fromJSON(object.stakeholder) : null,
    };
  },

  toJSON(message: ApiUpdateStakeholderRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.stakeholder !== undefined && message.stakeholder !== null) {
      obj.stakeholder = ApiStakeholderInput.toJSON(message.stakeholder);
    }
    return obj;
  },
};

export const ApiUpdateStakeholderResponse: MessageFns<ApiUpdateStakeholderResponse> = {
  fromJSON(object: any): ApiUpdateStakeholderResponse {
    return { stakeholder: isSet(object.stakeholder) ? ApiStakeholder.fromJSON(object.stakeholder) : null };
  },

  toJSON(message: ApiUpdateStakeholderResponse): unknown {
    const obj: any = {};
    if (message.stakeholder !== undefined && message.stakeholder !== null) {
      obj.stakeholder = ApiStakeholder.toJSON(message.stakeholder);
    }
    return obj;
  },
};

export const ApiUpdateStakeholderErrors: MessageFns<ApiUpdateStakeholderErrors> = {
  fromJSON(_: any): ApiUpdateStakeholderErrors {
    return {};
  },

  toJSON(_: ApiUpdateStakeholderErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
